export default "__VITE_ASSET__BtmTzkh0__"